@if (loaded) {
  <p-select
    [filter]="true"
    [options]="organizationList"
    [disabled]="disabled()"
    [ngModel]="organization"
    (ngModelChange)="organization = $event; onOrganizationChange($event)"
    placeholder="All organizations"
    appendTo="body"
    dataKey="id"
    [showClear]="true"
  >
  </p-select>
}
